// extracted by mini-css-extract-plugin
export default {"tetrisWrapper":"Tetris_tetrisWrapper__7df6B","tetris":"Tetris_tetris__B6s5q","startButton":"Tetris_startButton__FNp5H","helpButton":"Tetris_helpButton__vEZ4J"};